import React from 'react';
import { FormSubmissionsWidget } from 'containers/forms/formSubmissionsWidget';
import { FormsTabProps } from 'containers/forms/types';

export function FormsTab(props: FormsTabProps): React.ReactElement {
  return <FormSubmissionsWidget {...props} />;
}
